import { Measure } from '@wizeoo/akm-message-lib';

/**
 * l'expression d'une mesure
 */
export interface MeasMode {
    code: string; // mc#mm
    form: string; // formule
    m: Measure;
    mc: string; // code mesure
    mm: string; // mode mesure
    mmi: MeasModeItem;
    r: string; // result

    crDeps?: Set<string>; // dépendances inter-vision
    deps?: Set<string>; // dépendances autres mesures (dependency)
    stepDeps?: Set<number>; // dépendance autres steps
    legs?: Set<string>; // parent d'autres mesures (legacy)

    isErr?: boolean; // en erreur ?
    errC?: string; // code d'erreur
    errS?: string; // message d'erreur
    fake?: boolean;
    
    toBeC?: boolean; // doit être calculé
    w?: number; // poids ?
    useLocale?: boolean; // dépendant de la locale pour le calcul
}

/**
 * une étape de calcul dans un MeasMode
 */
export class MeasModeItem {
    cc?: string[]; // collection de contenu (fonctions d'aggrégat)
    c: MeasModeItem[]; // sous-contenu de calcul
    
    mm: MeasMode; // mesureMode porteur
    form: string; // formule brute
    r: string; // result

    isErr?: boolean; // en erreur ?
    errC?: string; // code d'erreur
    fake?: boolean;

    fColl?: boolean; // c'est une collection
    fComp?: boolean; // c'est un comparateur
    fConst?: boolean; // c'est une constante
    fFunc?: boolean; // c'est une fonction
    fRand?: boolean; // c'est une opérande (une mesure)
    fOper?: boolean; // c'est un opérateur
    fSis?: boolean; // c'est une parenthèse
    fTer?: boolean; // terminal (pas d'enfants)
    ftxt?: boolean; // c'est du texte
    funcCode?: string; // code de la fonction

    nbComp?: number; // combien de comparateurs

}